import React from 'react'
import { Link } from "react-router-dom"
import profileImage from "../../assets/img/BARUN.jpg"

function AdminNav({ active }) {
    console.log(active);
    return (
        <div>
            <header id="header">
                <div className="d-flex flex-column">
                    <div className="profile">
                        <img src={profileImage} alt="" className="img-fluid rounded-circle" />
                        <h1 className="text-light"><a href="index.html">Barun Kumar Pandey</a></h1>
                        <div className="social-links mt-3 text-center">
                            <a href="https://twitter.com/BarunKu63177728" target="_blank" rel="noreferrer" className="twitter"><i className="bx bxl-twitter"></i></a>
                            <a href="https://www.facebook.com/barun.pandey.372" target="_blank" rel="noreferrer" className="facebook"><i className="bx bxl-facebook"></i></a>
                            <a href="https://www.github.com/BarunPandey402" target="_blank" rel="noreferrer" className="instagram"><i className="bx bxl-github"></i></a>
                            <a href="https://www.linkedin.com/in/barun-kumar-pandey" target="_blank" rel="noreferrer" className="linkedin"><i className="bx bxl-linkedin"></i></a>
                        </div>
                    </div>

                    <nav className="nav-menu">
                        <ul>
                            <li className={active === "home" ? 'active' : ""}><Link to="/"><i className="bx bx-home"></i> <span>Home</span></Link></li>
                            <li className={active === "contactHistory" ? 'active' : ""}><Link to="/v1/admin/home"><i className="bx bx-file"></i> <span>Contact History</span></Link></li>
                            <li className={active === "feedbacks" ? 'active' : ""}><Link to="/v1/admin/feedbacks"><i className="bx bx-file"></i> <span>Feedbacks</span></Link></li>
                        </ul>
                    </nav>
                    <button type="button" className="mobile-nav-toggle d-xl-none"><i className="icofont-navigation-menu"></i></button>

                </div>
            </header>
        </div>
    )
}

export default AdminNav
